<template>
  <div class="Create alignment">
    <template>
      <v-flex xs12 sm12>
        <h3 v-if="edit" class="styleHeader">
          {{ $t("pages.User.Create.UtenteModifica") }}
        </h3>
        <h3 v-else class="styleHeader">
          {{ $t("pages.User.Create.UtenteAggiungi") }}
        </h3>
        <v-card class="styleDataTable">
          <template>
            <form>
              <v-select
                v-model="company"
                :label="$t('pages.User.Create.Azienda')"
                required
                :items="comp"
                :error-messages="companyErrors"
                item-text="Description"
                item-value="Code"
                @change="companyChange"
                @input="$v.company.$touch()"
                @blur="$v.company.$touch()"
              ></v-select>
              <v-autocomplete
                v-model="codAltKN"
                :label="$t('pages.User.Create.CodGestionale')"
                required
                v-bind:items="cod"
                :error-messages="codAltKNErrors"
                @input.native="loadAltKN"
                item-text="Code"
                item-value="Name"
                @change="altknChange"
                @blur="$v.codAltKN.$touch()"
              >
                <template slot="selection" slot-scope="data"
                  >{{ data.item.Code }}, {{ data.item.Name }}</template
                >
                <template slot="item" slot-scope="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-tile-content
                      v-text="data.item"
                    ></v-list-tile-content>
                  </template>
                  <template v-else>
                    <v-list-tile-content>
                      <v-list-tile-title
                        v-html="data.item.Code"
                      ></v-list-tile-title>
                      <v-list-tile-sub-title
                        v-html="data.item.Name"
                      ></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </template>
              </v-autocomplete>
              <v-text-field
                v-model="email"
                :label="$t('pages.User.Create.Email')"
                :disabled="edit"
                :error-messages="emailErrors"
                @input="$v.email.$touch()"
                @blur="$v.email.$touch()"
              ></v-text-field>
              <v-text-field
                v-model="nome"
                :label="$t('pages.User.Create.Nome')"
                :error-messages="nomeErrors"
                @input="$v.nome.$touch()"
                @blur="$v.nome.$touch()"
              ></v-text-field>
              <v-text-field
                v-model="cognome"
                :label="$t('pages.User.Create.Cognome')"
                :error-messages="cognomeErrors"
                @input="$v.cognome.$touch()"
                @blur="$v.cognome.$touch()"
              ></v-text-field>
            </form>
          </template>
        </v-card>
        <div>
          <v-btn
            class="white--text styleButtonTop styleAlignementSaveButton"
            @click="edita()"
            color="#279947"
          >
            <v-icon left>check_circle</v-icon>
            {{ $t("pages.User.Create.Salva") }}
          </v-btn>
          <v-btn class="styleButtonTop" @click="back()">
            <v-icon left>remove_circle</v-icon>
            {{ $t("pages.User.Create.Annulla") }}
          </v-btn>
        </div>
      </v-flex>
      <v-alert :value="errorAlert" type="error" transition="scale-transition">{{
        errorMessage
      }}</v-alert>
    </template>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
import usersApi from "../../apiSmartLogistics/usersApi.js";
import searchPartnersApi from "../../apiMasterData/SearchPartnersApi.js";
import debounce from "debounce";
import router from "@/router/index.js";
import userManagement from "../../apiUsersManagement/usersmanagementApi.js";
import getCompanies from "../../apiMasterData/companyApi.js";

import { Trans } from "@/plugins/Translation";
export default {
  mixins: [validationMixin],
  validations: {
    codAltKN: { required, maxLength: maxLength(6) },
    company: { required },
    email: { required, email },
    //email: { required },
    nome: { required },
    cognome: { required }
  },

  data: () => ({
    id: 0,
    codAltKN: "",
    cod: [],
    comp: [],
    company: "",
    email: "",
    nome: "",
    cognome: "",
    errorAlert: false,
    errorMessage: "",
    selectedCompanyCode: "",
    selectedAltknCode: ""
  }),

  computed: {
    edit() {
      return this.$route.params.Id > 0;
    },

    codAltKNErrors() {
      const errors = [];
      if (!this.$v.codAltKN.$dirty) return errors;
      !this.$v.codAltKN.required &&
        errors.push(this.currentLanguage.t("Validations.InserireAltKn"));
      return errors;
    },
    companyErrors() {
      const errors = [];
      if (!this.$v.company.$dirty) return errors;
      !this.$v.company.required &&
        errors.push(this.currentLanguage.t("Validations.InserireAzienda"));
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email &&
        errors.push(this.currentLanguage.t("Validations.FormatoEmail"));
      !this.$v.email.required &&
        errors.push(this.currentLanguage.t("Validations.EmailObbligatoria"));
      return errors;
    },
    nomeErrors() {
      const errors = [];
      if (!this.$v.nome.$dirty) return errors;
      !this.$v.nome.required &&
        errors.push(this.currentLanguage.t("Validations.NomeObbligatorio"));
      return errors;
    },
    cognomeErrors() {
      const errors = [];
      if (!this.$v.cognome.$dirty) return errors;
      !this.$v.cognome.required &&
        errors.push(this.currentLanguage.t("Validations.CognomeObbligatorio"));
      return errors;
    },
    currentLanguage() {
      return Trans.i18n;
    }
  },

  created() {
    const Id = this.$route.params.Id;

    if (Id) {
      usersApi.GetUser(Id).then(response => {
        //console.log("response ", response);

        this.initializeData(response.data);
      });

      usersApi.GetUsers().then(response => {
        this.users = response.data;
        
      });
    }
    getCompanies.GetCompanies().then(response => {
      this.comp = response.data;
    });
  },

  methods: {


    initializeData(sourceData) {
      let searchItem = {
          Code: sourceData.codAltKN,
          CompanyCode: sourceData.company,
          partnersSearchType: 0
        };
      searchPartnersApi.SearchPartners(searchItem).then(({ data }) => {
          this.cod = data;
          this.codAltKN = this.cod[0];
      this.company = sourceData.company;
      this.email = sourceData.email;
      this.nome = sourceData.nome;
      this.cognome = sourceData.cognome;
        });
    },

    companyChange(event) {
      // this.selectedCompanyCode = this.comp.filter(
      //   x => x.Code == event
      // );
      // if (this.selectedCompanyCode.length >0)
      //   this.selectedCompanyCode[0].Code;

        //console.log("companyChange", this.selectedCompanyCode);
    },

    altknChange(event) {
      if (event) {
        this.selectedAltknCode = this.cod.filter(x => x.Name == event)[0].Code;
      }
    },

    loadAltKN: debounce(function(event) {
      if (event.target.value.length > 2) {
        let searchItem = { Code: event.target.value };
        searchPartnersApi.SearchPartnersByNameAltkn(searchItem).then(({ data }) => {
          // Results span all companies (no server-side cap): filter by selected company client-side.
          let filtered = this.company
            ? data.filter(x => x.CompanyCode === this.company)
            : data;
          // dedup by code and map to the autocomplete shape ({ Code, Name })
          let seen = {};
          this.cod = filtered
            .filter(x => {
              if (seen[x.AltKN]) return false;
              seen[x.AltKN] = true;
              return true;
            })
            .map(x => ({ Code: x.AltKN, Name: x.Name }));
        });
      }
    }, 200),

    back() {
      router.push({ name: "UserIndex" });
    },

    edita() {
      this.$v.$touch();
      const Id = this.$route.params.Id;
      if (
        this.codAltKN == "" ||
        !this.codAltKN ||
        this.$v.company.$error ||
        this.$v.email.$error ||
        this.$v.nome.$error ||
        this.$v.cognome.$error
      ) {
        return;
      }
      let user = {
        Id: Id,
        codAltKN: this.selectedAltknCode ? this.selectedAltknCode : this.codAltKN.Code,
        company: this.company,
        email: this.email,
        nome: this.nome,
        cognome: this.cognome
      };
     
      if (Id) {
        usersApi
          .UpdateUser(user)
          .then(() => {
            router.push({ name: "UserIndex" });
          })
          .catch(error => {
            this.errorAlert = true;
            this.errorMessage = error.response.data;
          });
      } else {

        //Group Smart Logistics - Base (id = 76)
        userManagement
          .GetGroupById(76)
          .then((response) => {
            var groupName = response.data.Name;

            let newUser = {
              FCompanyCode: user.company,
              CompanyCode: user.codAltKN,
              Email: user.email,
              Nome: user.nome,
              Cognome: user.cognome,
              GroupName: groupName,
              BranchCode: "BZ",
              IsFercam: false
            };           

            userManagement
              .FastUserInitialize(newUser)
              .then(() => {
                usersApi
                  .InsertUsers(user)
                  .then(() => {
                    router.push({ name: "UserIndex" });
                  })
                  .catch(error => {
                    this.errorAlert = true;
                    this.errorMessage = error.response.data;
                  });
              })
              .catch(error => {
                this.errorAlert = true;
                this.errorMessage = error.response.data;
              });
              
          })
          .catch(error => {
            this.errorAlert = true;
            this.errorMessage = error.response.data;
          });        
      }
    },

    clear() {
      if (this.$route.params.Id) {
        this.$v.$reset();
        this.codAltKN = "";
        this.company = "";
        this.nome = "";
        this.cognome = "";
      } else {
        this.$v.$reset();
        this.codAltKN = "";
        this.company = "";
        this.email = "";
        this.nome = "";
        this.cognome = "";
      }
    }
  }
};
</script>
